/* Aubelys · sections aub-sql-* : galerie (points), minuteur jusqu'à minuit, offres (prix affiché), ajout au panier (tiroir du thème). */
(function () {
  'use strict';
  /* le fichier peut être inclus par plusieurs sections : une seule exécution, sinon chaque clic partirait plusieurs fois */
  if (window.aubSqlInit) return;
  window.aubSqlInit = true;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
  var eur = function (c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; };
  var pad = function (x) { return String(x).padStart(2, '0'); };

  $$('[data-aubs-gal]').forEach(function (g) {
    var tr = $('.aubs-gal__track', g), dots = $$('.aubs-dots button', g);
    if (!tr) return;
    dots.forEach(function (b, i) { b.onclick = function () { tr.scrollTo({ left: i * tr.clientWidth, behavior: 'smooth' }); }; });
    tr.addEventListener('scroll', function () { var k = Math.round(tr.scrollLeft / tr.clientWidth); dots.forEach(function (b, i) { b.setAttribute('aria-current', String(i === k)); }); }, { passive: true });
  });

  /* minuteur : jusqu'à minuit (heure du visiteur), comme la source */
  $$('[data-aubs-timer]').forEach(function (el) {
    var pat = el.getAttribute('data-pattern') || '[t]';
    var tick = function () { var now = new Date(), end = new Date(now); end.setHours(24, 0, 0, 0); var t = Math.max(0, (end - now) / 1000 | 0); el.textContent = pat.replace('[t]', pad(t / 3600 | 0) + ':' + pad(t / 60 % 60 | 0) + ':' + pad(t % 60)); };
    tick(); setInterval(tick, 1000);
  });

  $$('[data-aubs-buy]').forEach(function (col) {
    var now = $('[data-aubs-now]', col), was = $('[data-aubs-was]', col), radios = $$('.aubs-offer input', col);
    var btn = $('[data-aubs-atc]', col), msg = $('[data-aubs-msg]', col), cartEl = $('cart-drawer'), qty = 1;
    var sync = function () {
      var r = radios.filter(function (x) { return x.checked; })[0]; if (!r) return;
      qty = +r.value; var t = +r.getAttribute('data-total'), f = +r.getAttribute('data-full');
      if (now) now.textContent = eur(t);
      if (was) { was.textContent = eur(f); was.hidden = !(f > t); }
    };
    radios.forEach(function (x) { x.addEventListener('change', sync); }); sync();
    if (!btn) return;
    btn.addEventListener('click', function () {
      var body = { items: [{ id: +btn.getAttribute('data-variant'), quantity: qty }] };
      if (cartEl) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
      btn.disabled = true;
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (o) {
          btn.disabled = false;
          if (!o.ok) { if (msg) msg.textContent = o.j.description || 'Impossible d’ajouter le kit au panier.'; return; }
          if (msg) msg.textContent = '';
          if (cartEl && typeof cartEl.renderContents === 'function') { cartEl.renderContents(o.j); cartEl.classList.remove('is-empty'); var inn = cartEl.querySelector('.drawer__inner'); if (inn) inn.classList.remove('is-empty'); if (typeof cartEl.open === 'function' && !cartEl.classList.contains('active')) cartEl.open(); }
          else window.location = root + 'cart';
        })
        .catch(function () { btn.disabled = false; if (msg) msg.textContent = 'Une erreur est survenue, réessayez.'; });
    });
  });
})();
